import { useFetch } from '@/composables/useFetch';
import type { OnboardingStepDeps } from '@/composables/useOnboarding';
import i18n from '@/i18n';
import { createInfoStep } from '@/onboarding/stepStyles';
import { useEnvStore } from '@/stores/envStore';
import type { StepOptions } from 'shepherd.js';
import 'shepherd.js/dist/css/shepherd.css';
import { nextTick } from 'vue';
import type { Composer } from 'vue-i18n';

const t = (key: string, params: Record<string, unknown> = {}) => (i18n.global as unknown as Composer).t(key, params);
async function markOnboardingComplete() {
  localStorage.setItem('onboarding_completed', 'true');
  console.log('Onboarding marqué comme terminé localement.');

  // Appel API pour marquer l'onboarding comme terminé sur le serveur
  try {
    const { fetchData } = useFetch();
    const envStore = useEnvStore();

    const { data, error } = await fetchData(`${envStore.apiUrl}/onboarding/complete`, 'POST', {});

    if (error) {
      console.warn("Erreur lors de la synchronisation avec l'API:", error);
    } else {
      console.log("Onboarding terminé envoyé à l'API avec succès:", data);
    }
  } catch (error) {
    console.warn("Impossible de synchroniser l'état d'onboarding avec l'API:", error);
  }
}

export function getEndSteps({ tour }: OnboardingStepDeps): StepOptions[] {
  return [
    // END
    createInfoStep({
      id: 'end',
      title: t('onboarding.chapters.end.title'),
      text: t('onboarding.chapters.end.text', {
        dynamicText: t('onboarding.bold.chapter_9.gastronomia'),
      }),
      canClickTarget: false,
      beforeShowPromise: async () => {
        // On s'assure que le DOM est prêt si besoin
        await nextTick();
      },
      buttons: [
        {
          text: 'Revoir plus tard',
          secondary: true,
          action: () => {
            console.log('[Onboarding] Fermeture anticipée via "Revoir plus tard"');
            tour.value?.cancel();
          },
        },
        {
          text: 'Terminer',
          action: async () => {
            console.log('[Onboarding] Onboarding terminé avec succès');
            // Marque l'onboarding comme terminé (localStorage + API)
            await markOnboardingComplete();
            // Ferme Shepherd
            tour.value?.complete();
          },
        },
      ],
    }),
  ];
}

export { markOnboardingComplete };
